import { render } from "./ExamEventDetailedReport.vue?vue&type=template&id=4529ac77&scoped=true"
import script from "./ExamEventDetailedReport.vue?vue&type=script&lang=js"
export * from "./ExamEventDetailedReport.vue?vue&type=script&lang=js"

import "./ExamEventDetailedReport.vue?vue&type=style&index=0&id=4529ac77&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4529ac77"]])

export default __exports__